import React from 'react'

import Footer from '../organisation/footer/Footer';

import error from '../images/error.svg'

const NoPage = () => {


    return (
      <div>
        <div style={{backgroundColor: "white", padding: '9%'}}>
          <center>
      <img  style={{maxHeight: "430px", paddingleft: '10%'}} src={error} />
      </center>
        </div>
        <Footer/>
        </div>
    )


}

export default NoPage;